module.exports = {
  defaultLocale: "pl",
  localeDetection: false,
  locales: ["pl", "en", "de", "fr", "hu", "it", "cs"],
  // logger: () => null,
  pages: {
    "*": ["common"],
    "/": ["main"],
    "/contact": ["contact"],
    "rgx:^/pvc/": ["pvc"],
    // '/blog': ['blog'],
    // '/blog/[slug]': ['blog'],
    // '/blog/category': ['blog'],
    // '/blog/category/[slug]': ['blog'],
  },
};
